import React from 'react';
import { apiRequest } from '../actions/apiActions';
import { showLoading, hideLoading, addUiMsg } from '../actions/uiActions';
import { apiUrls, apiVersion } from '../../apiUrls';
import { FormattedMessage } from 'react-intl';
import { errorDisplay } from '../../utilities/general';
import { messageTypes } from '../../components/ui/AlertMessage';
import { objectToQueryString } from '../../utilities/httputils';
import {
  SUPPORT_ERROR,

  SUBMIT_ECHOSTREAM_MESSAGE,
  DISPLAY_ECHOSTREAM_DECODED_MESSAGE,

  SUBMIT_FKREPAIR_REQUEST,
  DISPLAY_FKREPAIR_RESPONSE,

  SUBMIT_ASCIIREPAIR_REQUEST,
  DISPLAY_ASCIIREPAIR_RESPONSE,

  GET_QUERYCATALOG_REQUEST,
  DISPLAY_QUERYCATALOG_RESPONSE,
  SUBMIT_QUERYEXECUTE_REQUEST,
  DISPLAY_QUERYEXECUTE_RESPONSE,
} from '../actions/supportActions';

/**
 * Middleware to process if an error occurs during the auth request
 * @param {object} action -The action triggered by the action creator
 * @fires dispatch#hideLoading - Hides the loader bar
 */
export const supportError = (store) => (next) => (action) => {
  next(action);
  if (action.type === SUPPORT_ERROR) {
    store.dispatch(hideLoading());
    const messageText = (
      <React.Fragment>
        <FormattedMessage
          id="supportMiddleware.supportErrorText"
          defaultMessage="There was an error; request to backend failed"
          description="Request to backend failed"
        />
      </React.Fragment>
    );
    const errors = action.payload;
    const message = {
      message: messageText,
      error: errorDisplay(errors),
      messageType: messageTypes.danger,
    };

    store.dispatch(addUiMsg(message));
  }
};

/**
 * Middleware to get the auth token
 * @param {object} action - The action triggered by the action creator
 * @fires dispatch#showLoading - Triggers the showing of the loader bar
 * @fires dispatch#apiRequest - Starts api request to retrieve the auth token
 */
export const submitEchostreamMessage = (store) => (next) => (action) => {
  next(action);
  if (action.type === SUBMIT_ECHOSTREAM_MESSAGE) {
    const message = action.payload.message
    const body = {
       ...message,
    };
    const meta = {
      method: 'POST',
      url: apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].asciiConverter,
      onSuccess: DISPLAY_ECHOSTREAM_DECODED_MESSAGE,
      onError: SUPPORT_ERROR,
      auth: store.getState().auth.token,
      body: body,
      setStateFunc: action.payload.setStateFunc,
    };
    store.dispatch(showLoading());
    store.dispatch(apiRequest(body, meta));
  }
};

/**
 * Middleware to stop the loader bar once the auth token has been retrieved
 * @param {object} action -The action triggered by the action creator
 * @fires dispatch#hideLoading - Hides the loader bar
 */
export const displayEchostreamDecodedMessage = ({ dispatch }) => (next) => (action) => {
  next(action);
  if (action.type === DISPLAY_ECHOSTREAM_DECODED_MESSAGE) {
    dispatch(hideLoading());
    action.meta.setStateFunc(action.payload.results)
  }
};

export const submitFkRepairRequest = (store) => (next) => (action) => {
  next(action);
  if (action.type === SUBMIT_FKREPAIR_REQUEST) {
    const apiBody = {
      'child_table' : action.payload.message.childTable,
      'child_field' : action.payload.message.childFieldName,
      'parent_table' : action.payload.message.parentTable,
      'repair_action' : action.payload.message.repairAction,
      'dryrun' : !action.payload.message.dryrun ?? false,
    }
    const meta = {
      method: 'POST',
      url: apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].fkRepair,
      onSuccess: DISPLAY_FKREPAIR_RESPONSE,
      onError: SUPPORT_ERROR,
      auth: store.getState().auth.token,
      body: apiBody,
      setStateFunc: action.payload.setStateFunc,
    };
    store.dispatch(showLoading());
    store.dispatch(apiRequest(apiBody, meta));
  }
};

export const displayFkRepairResponse = ({ dispatch }) => (next) => (action) => {
  next(action);
  if (action.type === DISPLAY_FKREPAIR_RESPONSE) {
    dispatch(hideLoading());
    const apiResults = JSON.stringify(action.payload)
    action.meta.setStateFunc(apiResults)
  }
};

export const submitAsciiRepairRequest = (store) => (next) => (action) => {
  next(action);
  if (action.type === SUBMIT_ASCIIREPAIR_REQUEST) {
    const apiBody = {
      'table' : action.payload.message.Table,
      'field' : action.payload.message.FieldName,
      'dryrun' : !action.payload.message.dryrun ?? false,
    }
    const meta = {
      method: 'POST',
      url: apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].asciiRepair,
      onSuccess: DISPLAY_ASCIIREPAIR_RESPONSE,
      onError: SUPPORT_ERROR,
      auth: store.getState().auth.token,
      body: apiBody,
      setStateFunc: action.payload.setStateFunc,
    };
    store.dispatch(showLoading());
    store.dispatch(apiRequest(apiBody, meta));
  }
};

export const displayAsciiRepairResponse = ({ dispatch }) => (next) => (action) => {
  next(action);
  if (action.type === DISPLAY_ASCIIREPAIR_RESPONSE) {
    dispatch(hideLoading());
    const apiResults = JSON.stringify(action.payload)
    action.meta.setStateFunc(apiResults)
  }
};


/* QUERY CATALOG */

export const getQueryCatalogRequest = (store) => (next) => (action) => {
  next(action);
  if (action.type === GET_QUERYCATALOG_REQUEST) {
    const meta = {
      method: 'GET',
      url: apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].queryCatalog,
      onSuccess: DISPLAY_QUERYCATALOG_RESPONSE,
      onError: SUPPORT_ERROR,
      auth: store.getState().auth.token,
      setStateFunc: action.payload.setStateFunc,
    };
    store.dispatch(showLoading());
    store.dispatch(apiRequest({}, meta));
  }
};

export const displayQueryCatalogResponse = ({ dispatch }) => (next) => (action) => {
  next(action);
  if (action.type === DISPLAY_QUERYCATALOG_RESPONSE) {
    dispatch(hideLoading());
    //console.log('Middleware: catalog: ', action.payload)
    action.meta.setStateFunc(action.payload)
  }
};

export const submitQueryExecuteRequest = (store) => (next) => (action) => {
  next(action);
  if (action.type ===  SUBMIT_QUERYEXECUTE_REQUEST) {
    const queryString = objectToQueryString(action.payload.urlParams)
    const apiBody = null
    const url = apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].queryCatalog + action.payload.queryId + '?' + queryString

    const meta = {
      method: 'GET',
      url: url,
      onSuccess: DISPLAY_QUERYEXECUTE_RESPONSE,
      onError: SUPPORT_ERROR,
      auth: store.getState().auth.token,
      body: apiBody,
      setStateFunc: action.payload.setStateFunc,
    };
    store.dispatch(showLoading());
    store.dispatch(apiRequest(apiBody, meta));
  }
};

export const displayQueryExecuteResponse = ({ dispatch }) => (next) => (action) => {
  next(action);
  if (action.type === DISPLAY_QUERYEXECUTE_RESPONSE) {
    dispatch(hideLoading());
    const apiResults = JSON.stringify(action.payload)
    action.meta.setStateFunc(apiResults)
  }
};


export const supportMdl = [
  supportError,
  submitEchostreamMessage, 
  displayEchostreamDecodedMessage,

  submitFkRepairRequest, 
  displayFkRepairResponse,

  submitAsciiRepairRequest, 
  displayAsciiRepairResponse,

  getQueryCatalogRequest,
  displayQueryCatalogResponse,
  submitQueryExecuteRequest, 
  displayQueryExecuteResponse
];
